import { decodeData, encodeData } from './crypt.util';
import { ENV, ENV_PROD } from '../constants/environment.constants';

function isProd(): boolean {
	return ENV === ENV_PROD;
}

export function setToLocalStorage(key: string, value: any): void {
	localStorage.setItem(key, isProd() ? encodeData(value) : value.toString());
}

export function getFromLocalStorage(key: string): any {
	const value: string | null = localStorage.getItem(key);
	if (!value) {
		return null;
	}
	return isProd() ? decodeData(value) : value;
}

export function removeFromLocalStorage(key: string): void {
	localStorage.removeItem(key);
}

export function setToSessionStorage(key: string, value: any): void {
	sessionStorage.setItem(key, isProd() ? encodeData(value) : value.toString());
}

export function getFromSessionStorage(key: string): any {
	const value: string | null = sessionStorage.getItem(key);
	if (!value) {
		return null;
	}
	return isProd() ? decodeData(value) : value;
}

export function removeFromSessionStorage(key: string): void {
	sessionStorage.removeItem(key);
}
